import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ShowVisibleNextAtd,
  addMessage,
  GetChatGroupUser,
  InterationNotifier,
  AlterScreen,
} from "../actions";
import { InviteChatGroups } from "../actions/websocket";
import MicroModal from "micromodal";
import Moment from "moment";
import _ from "lodash";
import Highlighter from "react-highlight-words";
import { CURRENTSCREEN } from "../constants/ActionTypes";
import latinize from "latinize";

const { meses } = require("../services/data");

function makeid(length) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

const mapStateToProps = (state) => {
  return {
    DisplayNextAtd: state.displaynextatd,
    DisplayDetails: state.displaydetailsatd,
    UserGroups: state.listgroupmsg,
    Messages: state.messages,
    InfoUsers: state.informationusers,
    CurrentScreen: state.currentscreen,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ShowVisibleNextAtdIn: (post, temp) => {
    dispatch(ShowVisibleNextAtd(post, temp));
  },
  InviteChatGroups: (
    makeid,
    message,
    author,
    infousers,
    typemsg,
    msgsocket,
    groupsSelecGrupo,
    warning
  ) => {
    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    if (message !== "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          -333,
          typemsg,
          "Enviado",
          false,
          dia
        ),
        InviteChatGroups(
          infousers,
          msgsocket,
          makeid,
          groupsSelecGrupo,
          warning
        )
      );
    }
  },
  AlterScreen: (post) => {
    dispatch(AlterScreen(post));
  },
  getHistoryChatGroup: (userin, datainit) => {
    GetChatGroupUser(userin, datainit)(dispatch);
  },
  InterationNotifier: (texto, status) => {
    dispatch(InterationNotifier(texto, status));
  },
});

class TeamModal extends Component {
  constructor(props) {
    var storageGroup = localStorage.getItem("team_group_filter") || [];
    if (storageGroup.length !== 0) {
      storageGroup = storageGroup.split(",").map(Number);
    }
    super(props);
    this.state = {
      visible: "",
      arrowterm: 0,
      activeconsulta: false,
      expand_less_count: 0,
      expand_more_count: 0,
      fileasw: [],
      buttonfilter: false,
      scroller: 0,
      buttonfilter2: false,
      searchText: "",
      filterGroup: "",
      keyGroup: storageGroup,
      auxkeyGroup: storageGroup,
      filterActual: "Histórico por Data",
    };
    this.scrollDown = this.scrollDown.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    this.scrollDown();
  }

  GetTermText(event) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;
    this.setState({
      searchText: event.target.value,
      arrowterm: 0,
      expand_more_count: tam,
    });

    if (tam === 0) {
      this.setState({ expand_less_count: 0 });
    } else {
      this.setState({ expand_less_count: 1 });
    }
  }

  handleKeyUp(inf) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;

    if (tam >= this.state.arrowterm + 1) {
      elems[this.state.arrowterm].scrollIntoView(false);
      if (inf == "less") {
        if (this.state.arrowterm !== 0) {
          this.state.arrowterm = this.state.arrowterm - 1;
          if (this.state.expand_less_count !== 1)
            this.setState({
              expand_less_count: this.state.expand_less_count - 1,
            });
        }
      } else {
        this.state.arrowterm = this.state.arrowterm + 1;
        if (this.state.expand_less_count !== this.state.expand_more_count)
          this.setState({
            expand_less_count: this.state.expand_less_count + 1,
          });
      }
    } else {
      if (elems[this.state.arrowterm]) {
        this.state.arrowterm = 1;
        elems[this.state.arrowterm].scrollIntoView(false);
      }
    }
    if (tam === this.state.arrowterm) {
      if (inf == "less") {
        this.state.arrowterm = this.state.arrowterm - 1;
        this.setState({ expand_less_count: this.state.expand_less_count - 1 });
      }
    }
  }

  ShowFiltersChat(e) {
    e.preventDefault();
    this.setState({ buttonfilterchat: !this.state.buttonfilterchat });
  }

  handleClick() {
    this.setState((state) => ({
      activeconsulta: !state.activeconsulta,
      searchText: "",
      expand_less_count: 0,
      expand_more_count: 0,
    }));
  }

  ShowFilters2(e) {
    //e.preventDefault();
    this.setState({ buttonfilter2: !this.state.buttonfilter2 });
  }

  scrollDown() {
    const { container } = this.refs;
    if (this.state.scroller !== container.scrollHeight) {
      container.scrollTop = container.scrollHeight;
      this.state.scroller = container.scrollHeight;
    }
  }

  ButtonSendMessage(event, author, InfoUsers, typemsg) {

    
    event.preventDefault();
    let groupsSelecGrupo = this.state.keyGroup;
    let warning = this.state.warning;
    if (groupsSelecGrupo.length !== 0) {
      document.getElementById("chat-message-group").disabled = false;
      let msgweb = document.getElementById("chat-message-group").innerText;
      let msgsocket = document.getElementById("chat-message-group").innerText;
      msgsocket = msgsocket.replace(/"/gi, "'");


      let infosendfile = this.state.fileasw;

      if (
        this.state.fileasw !== null &&
        infosendfile[2] !== 1 &&
        infosendfile.length > 0
      ) {
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        let str = msgweb.replace(/\s/g, "");
        if (str !== "") {
          this.props.sendFileAswSocket(
            InfoUsers,
            infosendfile[0],
            msgweb,
            makeid(32)
          );
          this.props.sendImageAsw(
            makeid(32),
            " ~¿" + msgweb + "~¿" + infosendfile[0],
            InfoUsers.id,
            InfoUsers,
            1
          );
        }
      } else {
        let str = msgweb.replace(/\s/g, "");
        
        if (str !== "") {
          msgweb = msgweb.trim();
          msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          msgsocket = msgsocket.trim();
          msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
          this.props.InviteChatGroups(
            makeid(32),
            msgweb,
            InfoUsers.id,
            InfoUsers,
            typemsg,
            msgsocket,
            groupsSelecGrupo,
            warning
          );
        }
      }

      this.scrollDown();
      document.getElementById("chat-message-group").innerHTML = "";
      this.textInputGroup.focus();
    } else {
      this.props.InterationNotifier(
        "Favor selecionar pelo menos um Grupo",
        "toastgrupo"
      );
    }
  }

  handleOnChangeGroup(event, InfoUsers) {
    let groupsSelecGrupo = this.state.keyGroup;
    let warning = this.state.warning;
    if (event.key === "Enter" && event.shiftKey === false) {
      if (groupsSelecGrupo.length !== 0) {
        let teste = document.getElementsByClassName("chat-message-group");
        let msgweb = document.getElementById("chat-message-group").innerText;
        let msgsocket = document.getElementById("chat-message-group").innerText;

        msgsocket = msgsocket.replace(/"/gi, "'");

  
        let str = msgweb.replace(/\s/g, "");
        if (str !== "") {
          msgweb = msgweb.trim();
          msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
          msgsocket = msgsocket.trim();
          msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
          this.props.InviteChatGroups(
            makeid(32),
            msgweb,
            InfoUsers.id,
            InfoUsers,
            "0",
            msgsocket,
            groupsSelecGrupo,
            warning
          );
          document.getElementById("chat-message-group").innerHTML = "";
          this.scrollDown();
          //this.props.sendtyping(0, InfoUsers, Chat);
        }
      } else {
        this.props.InterationNotifier(
          "Favor selecionar pelo menos um Grupo",
          "toastgrupo"
        );
      }
    } else {
      //this.props.sendtyping(1, InfoUsers, Chat);
    }
  }

  changeGroupChat(e) {
    this.setState({ filterGroupChat: e.target.value });
  }

  GetHistoryChat(e, action, userin, atual) {
    var date = Moment().format("YYYY-MM-DD 00:00:00");
    switch (action) {
      case "1":
        date = Moment().format("YYYY-MM-DD 00:00:00");
        break;
      case "2":
        date = Moment().subtract(1, "days");
        date = date.format("YYYY-MM-DD 00:00:00");
        break;
      case "3":
        date = Moment().subtract(7, "days");
        date = date.format("YYYY-MM-DD 00:00:00");
        break;
      case "4":
        date = Moment().subtract(14, "days");
        date = date.format("YYYY-MM-DD 00:00:00");
        break;
      case "5":
        date = Moment().subtract(31, "days");
        date = date.format("YYYY-MM-DD 00:00:00");
        break;
      case "6":
        date = Moment().subtract(62, "days");
        date = date.format("YYYY-MM-DD 00:00:00");
        break;
      case "7":
        date = Moment().subtract(93, "days");
        date = date.format("YYYY-MM-DD 00:00:00");
        break;
    }
    this.props.getHistoryChatGroup(userin, date);
    this.ShowFilters2();
    this.setState({ filterActual: atual });
  }

  handleKeyPressGroup = (event) => {
    var el = document.getElementById("chat-message-group");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  handleKeyDownGroup = (event) => {
    var el = document.getElementById("chat-message-group");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  filterGroupChat(e, idgroup, description) {
    let array = this.state.groupsSelecGrupo;
    let groupfilter = [];
    if (e.target.checked) {
      this.setState({
        keyGroup: this.state.keyGroup.concat([idgroup]),
      });
      this.setState({
        auxkeyGroup: this.state.auxkeyGroup.concat([idgroup]),
      });
      //array.push({idgroup: idgroup, description: description})
      this.setState({ groupsSelecGrupo: array });
      groupfilter = this.state.keyGroup.concat([idgroup]);
    } else {
      this.setState({
        keyGroup: this.state.keyGroup.filter(function (val) {
          return val !== idgroup;
        }),
      });
      this.setState({
        auxkeyGroup: this.state.auxkeyGroup.filter(function (val) {
          return val !== idgroup;
        }),
      });
      groupfilter = this.state.keyGroup.filter(function (val) {
        return val !== idgroup;
      });
    }
    localStorage.setItem("team_group_filter", groupfilter);
  }

  handleActiveAlert(e) {
    this.setState({ warning: !this.state.warning });
  }

  render() {
    var dia = "";
    var auxdia = "";
    const { UserGroups, Messages, InfoUsers, CurrentScreen } = this.props;
    const { searchText } = this.state;
    const searchWords = searchText.split(/\s/).filter((word) => word);
    let input;
    var typing_w = "";
    var enableMsg = false;

    if (Messages.length !== 0) {
      var NovaMensagem = Messages[-333];
      var Contador = [];

      if (NovaMensagem === undefined) {
        var NovaMensagem = [];
      }
    } else {
      var NovaMensagem = [];
    }

    if (Messages.length !== 0) this.state.messages = Messages;

    if (UserGroups.length !== 0) {
      this.state.groups = UserGroups.groups;
    } else {
      this.state.grupos = [];
    }

    const listin = this.state.groups || [];
    this.state.groups = _.filter(listin, (group) => {
      let arrayGroup = [group.name];
      return !_.isEmpty(this.state.filterGroupChat)
        ? arrayGroup
            .toString()
            .toLowerCase()
            .indexOf(this.state.filterGroupChat.toString().toLowerCase()) > -1
        : true;
    });

    this.state.groups.map((group, index) => (enableMsg = true));

    return (
      <div className="modal__overlay" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__mensagem-equipe__title"
        >
          <header className="modal__header">
            <h2 className="modal__title" id="modal__mensagem-equipe__title">
              Mensagem para equipe
            </h2>
            <button
              className="modal__close"
              aria-label="Close modal"
              data-micromodal-close
              onClick={() => this.props.AlterScreen(CurrentScreen.previous)}
            ></button>
          </header>
          <div className="modal__header__bottom-line"></div>
          <main
            className="modal__content--med"
            id="modal__mensagem-equipe__content"
          >
            <div className="modal__content__form">
              <div className="modal__content__form__filter">
                <div className="modal__content__form__filter__item">
                  <div
                    className={
                      this.state.buttonfilterchat
                        ? "select card--no-mg active"
                        : "select card--no-mg"
                    }
                  >
                    <button
                      className="select__btn"
                      type="button"
                      id="mult-filter-inside"
                      onClick={this.ShowFiltersChat.bind(this)}
                    >
                      Selecione o(s) grupo(s)
                      <i className="select__icon material-icons">
                        keyboard_arrow_right
                      </i>
                    </button>
                    <div className="options options--advanced">
                      <div className="options--advanced__search-box">
                        <div className="full-search">
                          <input
                            className="full-search__input full-search__input--padding"
                            onChange={(event) => this.changeGroupChat(event)}
                            type="text"
                            name="client-search"
                            id="client-search"
                            placeholder="Busca..."
                          />
                          <button type="text" className="full-search__btn">
                            <i className="material-icons">search</i>
                          </button>
                        </div>
                      </div>
                      <div className="options--advanced__filter-box">
                        <div className="options--advanced__filter-box__content">
                          <div className="checkbox checkbox__list">
                            <div className="checkbox__list__title">Grupos</div>
                            {this.state.groups.map((group, index) => (
                              <li className="checkbox__item" key={index}>
                                <input
                                  className="checkbox__list__input"
                                  id={"checkbox-geral-grupo" + group.id}
                                  name={"checkbox-geral-grupo" + group.id}
                                  type="checkbox"
                                  defaultChecked={
                                    this.state.keyGroup.findIndex(function (
                                      val
                                    ) {
                                      return val === group.id;
                                    }) !== -1
                                      ? true
                                      : false
                                  }
                                  onChange={(event) =>
                                    this.filterGroupChat(
                                      event,
                                      group.id,
                                      group.name
                                    )
                                  }
                                />
                                <label
                                  htmlFor={"checkbox-geral-grupo" + group.id}
                                >
                                  {group.name}
                                </label>
                              </li>
                            ))}
                          </div>
                          {/* <!-- SITE --> */}
                          {/* <div className="checkbox checkbox__list">                            
                                    <div className="checkbox__list__title">Site</div>                                                            
                                    <li className="checkbox__item">
                                        <input className="checkbox__list__input" id="checkbox-geral1" type="checkbox" value="Geral"/>                
                                        <label htmlFor="checkbox-geral1">Geral</label>    
                                    </li> 
                                    <li className="checkbox__item">
                                        <input className="checkbox__list__input" id="checkbox-financeiro1" type="checkbox" value="Financeiro"/>                
                                        <label htmlFor="checkbox-financeiro1">Financeiro</label>    
                                    </li>                                 
                                    <li className="checkbox__item">
                                        <input className="checkbox__list__input" id="checkbox-comercial1" type="checkbox" value="comercial"/>                
                                        <label htmlFor="checkbox-comercial1">Comercial</label>    
                                    </li> 

                                    <li className="checkbox__item">
                                        <input className="checkbox__list__input" id="checkbox-tecnologia1" type="checkbox" value="tecnologia"/>                
                                        <label htmlFor="checkbox-tecnologia1">Tecnologia</label>    
                                    </li> 
                                    </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal__content__form__filter__item">
                  <div
                    className={
                      this.state.buttonfilter2 ? "select active" : "select "
                    }
                  >
                    <button
                      className="select__btn"
                      type="button"
                      data-pausa="Atendimento Presencial Cliente"
                      onClick={this.ShowFilters2.bind(this)}
                    >
                      {this.state.filterActual}
                      <i className="select__icon material-icons">
                        keyboard_arrow_right
                      </i>
                    </button>
                    <div className="options ">
                      <ul className="pausa__list">
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "1",
                              InfoUsers.id,
                              "Hoje"
                            )
                          }
                        >
                          <p className="pausa__label">Hoje</p>
                        </li>
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "2",
                              InfoUsers.id,
                              "Ontem"
                            )
                          }
                        >
                          <p className="pausa__label">Ontem</p>
                        </li>
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "3",
                              InfoUsers.id,
                              "Há uma semana"
                            )
                          }
                        >
                          <p className="pausa__label">Há uma semana</p>
                        </li>
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "4",
                              InfoUsers.id,
                              "Há duas semanas"
                            )
                          }
                        >
                          <p className="pausa__label">Há duas semanas</p>
                        </li>
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "5",
                              InfoUsers.id,
                              "Há 1 meses"
                            )
                          }
                        >
                          <p className="pausa__label">Há 1 mês</p>
                        </li>
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "6",
                              InfoUsers.id,
                              "Há 2 meses"
                            )
                          }
                        >
                          <p className="pausa__label">Há 2 meses</p>
                        </li>
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "7",
                              InfoUsers.id,
                              "Há 3 meses"
                            )
                          }
                        >
                          <p className="pausa__label">Há 3 meses</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal__chat-wrapper">
                <div className="block full-height no-margin-bottom" id="chat">
                  <div className="block-header">
                    <div className="column-user-details">
                      {/* <div className="user-name is-poppins">
                                <!-- <span className="user-name__channel"><img src="build/images/facebook.svg" alt="" className="user-name__channel-img"></span> -->
                                Grupo de Estudos</div> */}

                      {/* <div className="user-time--content">
                                <div className="user-time">
                                    <i className="far fa-calendar"></i> <span className="time">12/12/12</span>
                                </div>
                                <div className="user-time">
                                    <i className="far fa-clock"></i> <span className="time">00:10:12</span>
                                </div>
                                </div>   */}
                    </div>

                    <div
                      className={
                        this.state.activeconsulta
                          ? "block-header__search-box is-active"
                          : "block-header__search-box"
                      }
                    >
                      <div className="block-header__search-box-nav">
                        <div className="block-header__search-box-content-input">
                          <input
                            type="text"
                            placeholder="Pesquisar mensagens..."
                            autoFocus={true}
                            onChange={(event) => this.GetTermText(event)}
                            className="block-header__search-box-input"
                          />

                          <div className="block-header__search-box-content-count">
                            {this.state.expand_less_count} de{" "}
                            {this.state.expand_more_count}
                          </div>
                        </div>

                        <div className="block-header__search-box-content-icon">
                          <a className="block-header__search-box-icon material-icons">
                            expand_less
                          </a>
                          <a className="block-header__search-box-icon material-icons">
                            expand_more
                          </a>
                        </div>
                        <button
                          className="block-header__search-box-button"
                          onClick={this.handleClick}
                        >
                          Concluir
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="block-content chat-canvas">
                    <div className="chat-canvas__content" ref="container">
                      {NovaMensagem.map((message, i) => {
                        var positmessage1 = "message left";
                        var positmessage2 = "fav fav--left";
                        if (
                          parseInt(message.author) === parseInt(InfoUsers.id)
                        ) {
                          positmessage1 = "message right";
                          positmessage2 = "fav fav--right";
                        }
                        if (message.dia !== auxdia) {
                          dia = message.dia;
                          auxdia = message.dia;
                        } else {
                          auxdia = message.dia;
                          dia = "";
                        }
                        var verifystar = this.state.active;
                        var mensagem_tratada = message.message.replace(
                          /¿/gi,
                          "\n"
                        );
                        if (message.typemsg === "2") {
                          var mensagem_tratada = mensagem_tratada.replace(
                            /§/gi,
                            "\r\n"
                          );
                        }
                        if (
                          parseInt(message.author) === InfoUsers.id &&
                          -333 === message.iduserout &&
                          message.typemsg === "0"
                        )
                          return (
                            <div key={i} className={positmessage1}>
                              <div className="time">{dia}</div>
                              <div className="bubble">
                                <div
                                  className={
                                    message.favorite === "true"
                                      ? positmessage2 + " active"
                                      : positmessage2
                                  }
                                >
                                  {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                </div>
                                <div
                                  className="text"
                                  style={{ whiteSpace: "pre-line" }}
                                >
                                  <Highlighter
                                    highlightClassName="YourHighlightClass1"
                                    activeIndex="YourHighlightClass1"
                                    activeClassName="YourHighlightClass1"
                                    className="NovClass"
                                    searchWords={searchWords}
                                    textToHighlight={mensagem_tratada}
                                    sanitize={latinize}
                                  />
                                  <span className="text__end-spacing"></span>
                                </div>
                                <div className="bubble__info-content">
                                  <div
                                    className="fav fav--inside fav--right"
                                    style={{ display: "none" }}
                                  >
                                    <i className="material-icons fav-icon">
                                      star_border
                                    </i>
                                  </div>
                                  <div className="bubble__info-content__time">
                                    {message.datatime}
                                  </div>
                                  {(() => {
                                    if (positmessage1 !== "message left") {
                                      return (
                                        <div
                                          className={
                                            "message-info message-info--" +
                                            message.statusmsg
                                          }
                                        >
                                          <i className="material-icons">
                                            done_all
                                          </i>
                                        </div>
                                      );
                                    }
                                  })()}
                                </div>
                              </div>
                            </div>
                          );
                        else if (
                          parseInt(-333) === parseInt(message.contactid) &&
                          message.typemsg === "0"
                        )
                          return (
                            <div key={i} className={positmessage1}>
                              <div className="time">{dia}</div>
                              <div className="bubble">
                                <div
                                  className={
                                    message.favorite === "true"
                                      ? positmessage2 + " active"
                                      : positmessage2
                                  }
                                >
                                  {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                                </div>
                                <div
                                  className="text"
                                  style={{ whiteSpace: "pre-line" }}
                                >
                                  <Highlighter
                                    highlightClassName="YourHighlightClass"
                                    searchWords={searchWords}
                                    autoEscape={true}
                                    textToHighlight={mensagem_tratada}
                                  />
                                  <span className="text__end-spacing"></span>
                                </div>
                                <div className="bubble__info-content">
                                  <div
                                    className="fav fav--inside fav--right"
                                    style={{ display: "none" }}
                                  >
                                    <i className="material-icons fav-icon">
                                      star_border
                                    </i>
                                  </div>
                                  <div className="bubble__info-content__time">
                                    {message.datatime}
                                  </div>
                                  {(() => {
                                    if (positmessage1 !== "message left") {
                                      return (
                                        <div
                                          className={
                                            "message-info message-info--" +
                                            message.statusmsg
                                          }
                                        >
                                          <i className="material-icons">
                                            done_all
                                          </i>
                                        </div>
                                      );
                                    }
                                  })()}
                                </div>
                              </div>
                            </div>
                          );
                      })}
                      {typing_w}
                    </div>
                  </div>
                  <div className="block-footer">
                    <div className="message-box">
                      <div className="input-message">
                        {/* <!-- <input className="emoji-container" type="text" name="chat-message" id="chat-message" placeholder="Escreva sua mensagem..."> --> */}
                        <div
                          className="chat-message"
                          id="chat-message-group"
                          onKeyPress={this.handleKeyPressGroup}
                          ref={(input) => {
                            this.textInputGroup = input;
                          }}
                          onKeyDown={this.handleKeyDownGroup}
                          onKeyUp={(event) =>
                            this.handleOnChangeGroup(event, InfoUsers)
                          }
                          contentEditable={enableMsg}
                        ></div>

                        {/* <!-- <textarea onkeyup="textAreaAdjust(this)" className="emoji-container chat-message" type="text" name="chat-message" id="chat-message" placeholder="Escreva sua mensagem..."></textarea> --> */}
                        <button
                          type="submit"
                          className="send-message btn btn--only-icon-mini-chat"
                          disabled={enableMsg === true ? false : true}
                          onClick={(event) =>
                            this.ButtonSendMessage(
                              event,
                              InfoUsers.id,
                              InfoUsers,
                              "0"
                            )
                          }
                        >
                          <i className="material-icons">send</i>
                        </button>
                      </div>
                      <a
                        className="btn action with-icon premade-msg-btn chat-special tippy-default"
                        id="action-premade-messages"
                        disabled
                        data-tippy-content="Mensagens predefinidas"
                      >
                        <i className="material-icons">chat_bubble_outline</i>
                      </a>

                      {/* <!-- PREMADE MESSAGES BOX --> */}
                      <div className="premade-msg">
                        <p className="premade-msg__title">Respostas rápidas</p>
                        <div className="premade-msg__content">
                          <ul className="premade-msg__list">
                            <li className="premade-msg__item">
                              Estou pesquisando. Por favor aguarde.
                            </li>
                            <li className="premade-msg__item">
                              Um momento, por favor.
                            </li>
                            <li className="premade-msg__item">
                              Já tenho o seu numero de protocolo. Pode anotar?
                            </li>
                            <li className="premade-msg__item">
                              Um momento, por favor.
                            </li>
                          </ul>
                          <div className="premade-msg__input-wrapper">
                            <input
                              type="text"
                              className="premade-msg__search-input"
                              onClick={this.handleClick}
                              placeholder="Pesquise uma resposta..."
                            />
                            <span className="premade-msg__input-icon">
                              <i className="material-icons">search</i>
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* <!-- END PREMADE MESSAGES BOX --> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal__content__form__group modal__content__form__group--col-8">
                <div className="checkbox__item">
                  <input
                    className="checkbox__list__input"
                    id="checkbox-alerta"
                    name="checkbox-alerta"
                    onChange={(event) => this.handleActiveAlert(event)}
                    type="checkbox"
                    checked={this.state.warning === true ? true : false}
                  />
                  <label htmlFor="checkbox-alerta">Ativar alerta</label>
                </div>
              </div>
              <button onClick={this.handleClick} className="hist-atd__fab">
                <i className="material-icons">search</i>
              </button>
            </div>
          </main>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TeamModal);
